import React from 'react';
import moment from 'moment'
import { pure } from 'recompose';
import { Link, withRouter } from 'react-router-dom';
import { ICONS } from 'modules/common/components/icon/Icons';
import { Card, CardImage, CardContent, CardHeader, CardInfoWithIcon, CardPrice } from 'modules/common/components/ui/Card';
import { formatDateRange } from 'utils/date-utils';
import { formatPrice } from 'utils/price-utils';
import withLocalized from 'modules/localization/withLocalized';

const currencyLocale = process.env.REACT_APP_NODE_ENV === 'ie' ? 'en-GB' : 'fi-FI';

const onClick = (event, history, linkProps) => {
  event.preventDefault()
  history.push(linkProps);
}

const EventCard = (props) => {
  
  const {
    event: {
      id,
      title,
      image,
      place,
      date_from,
      date_to,
      participants_count,
      participants_max,
      prices = [],
      currency,
    } = {},
    history,
    location: {
      pathname,
      search,
    },
    localized,
    courseAddress,
    className = undefined,
    fluid = false,
    onMouseOver = () => {},
    onMouseOut = () => {},
    activeOnHover = false,
    active = false,
    children,
  } = props;
  
  const lowestPrice = Math.min(...prices.map(p => parseInt(p.price_value, 10)))
  
  const pricePrefix  = prices.length > 1 ? `${localized('search.results.price_from')} ` : ''

  const imageSrc = image instanceof Array && image.length > 0 ? image[0].formatted_large : undefined;
  
  const linkProps = {
    pathname: `/events/${id}`,
    state: { backLink: pathname + search }
  };

  const formattedDates = formatDateRange(moment(date_from), moment(date_to));

  const canBeBooked = parseInt(participants_count, 10) < parseInt(participants_max, 10);

  return (
    <Card
      clickable fluid={fluid}
      activeOnHover={activeOnHover}
      active={active}
      className={className}
      onMouseOver={e => onMouseOver(props.event)}
      onMouseOut={onMouseOut}
      onClick={event => onClick(event, history, linkProps)}
    >
      <Link className="card__anchor" to={linkProps}>
        <CardImage src={imageSrc} />
        { (lowestPrice !== '' && !isNaN(lowestPrice) && canBeBooked) && <CardPrice>{`${pricePrefix}${formatPrice(lowestPrice, currency, currencyLocale)}`}</CardPrice> }
        { !canBeBooked && <CardPrice disabled>{localized('search.results.cta_event_link_fullybooked')}</CardPrice>}
      </Link>
      <CardContent>
        <CardHeader>
          <Link to={linkProps}>{title}</Link>
        </CardHeader>
        <CardInfoWithIcon icon={ICONS.CALENDAR}>{formattedDates}</CardInfoWithIcon>
        {place && (
          <CardInfoWithIcon icon={ICONS.PIN_FLAG}>
            <span dangerouslySetInnerHTML={{__html:  place || '-'}}/>
          </CardInfoWithIcon>)
        }
        { courseAddress && <CardInfoWithIcon icon={ICONS.LOCATION}>{courseAddress}</CardInfoWithIcon> }
      </CardContent>
      { children }
    </Card>
  )
};

export default pure(withLocalized(withRouter(EventCard)));



// WEBPACK FOOTER //
// ./src/modules/events/components/EventCard.js